<div class="sm-shell" [class.sm-sheet-full]="sheetState === 'full'">

  <header class="sm-header">
    <h1 class="sm-title">Stitch Maker</h1>
  </header>

  <div class="sm-canvas-wrap" #canvasWrap
       (touchstart)="onCanvasTouchStart($event)"
       (touchmove)="onCanvasTouchMove($event)"
       (touchend)="onCanvasTouchEnd($event)"
       (wheel)="onCanvasWheel($event)">
    <div class="sm-canvas">
      <div class="grid" [style.transform]="gridTransform()" style="transform-origin:0 0">
        <div *ngFor="let row of grid; let rowIndex = index" class="grid-row">
          <div
            *ngFor="let cell of row; let colIndex = index"
            class="grid-cell"
            [class.grid-cell-no-lines]="!showGridLines"
            (click)="onCellClick(rowIndex, colIndex)">
            <svg *ngIf="cell.paletteItemId"
                 width="100%" height="100%" viewBox="0 0 24 24"
                 [style.color]="colorFor(cell.paletteItemId)"
                 [innerHTML]="symbolMarkupFor(cell.paletteItemId) | safeHtml"></svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <aside class="sm-drawer">
    <div class="sm-drawer-handle"
         (touchstart)="onSheetTouchStart($event)"
         (touchend)="onSheetTouchEnd($event)"
         (click)="setSheetState(sheetState === 'peek' ? 'full' : 'peek')"></div>

    <div class="sm-pinned-row">
      <ng-container *ngFor="let id of recentPaletteItemIds">
        <ng-container *ngIf="paletteItemById.get(id) as item">
          <div role="button" tabindex="0"
               class="sm-chip"
               [class.sm-chip-active]="item.id === activePaletteItemId"
               [style.background]="item.color"
               [title]="item.name || item.color"
               (click)="activateChip(item.id)"
               (keydown.enter)="activateChip(item.id)"
               (keydown.space)="activateChip(item.id); $event.preventDefault()">
            <svg class="sm-chip-symbol"
                 [class.sm-chip-symbol-dark]="isLightColor(item.color)"
                 width="20" height="20" viewBox="0 0 24 24"
                 [innerHTML]="(symbolById.get(item.symbolId)?.svg || '') | safeHtml"></svg>
            <button type="button"
                    class="sm-chip-edit"
                    (click)="openPaletteEditor(item.id); $event.stopPropagation()"
                    title="Edit">✎</button>
          </div>
        </ng-container>
      </ng-container>
      <button type="button" class="sm-add-btn" (click)="addPaletteItem()" title="Add palette entry">+</button>
    </div>

    <div class="sm-drawer-scroll">

      <section class="sm-section">
        <h2 class="sm-section-title">Stitch type</h2>
        <div class="sm-pill-row">
          <button type="button" class="sm-pill" [class.sm-pill-on]="selectedStitchType === 'full'"
                  (click)="selectedStitchType = 'full'">Full</button>
          <button type="button" class="sm-pill" [class.sm-pill-on]="selectedStitchType === 'half'"
                  (click)="selectedStitchType = 'half'">Half</button>
          <button type="button" class="sm-pill" [class.sm-pill-on]="selectedStitchType === 'quarter'"
                  (click)="selectedStitchType = 'quarter'">¼</button>
          <button type="button" class="sm-pill" [class.sm-pill-on]="selectedStitchType === 'three-quarter'"
                  (click)="selectedStitchType = 'three-quarter'">¾</button>
          <button type="button" class="sm-pill" [class.sm-pill-on]="selectedStitchType === 'french-knot'"
                  (click)="selectedStitchType = 'french-knot'">Knot</button>
        </div>
      </section>

      <section class="sm-section">
        <h2 class="sm-section-title">Full palette · {{ palette.length }} {{ palette.length === 1 ? 'color' : 'colors' }}</h2>
        <div class="sm-palette-grid">
          <div role="button" tabindex="0"
               *ngFor="let item of palette; trackBy: trackByPaletteId"
               class="sm-chip"
               [class.sm-chip-active]="item.id === activePaletteItemId"
               [style.background]="item.color"
               [title]="item.name || item.color"
               (click)="activateChip(item.id)"
               (keydown.enter)="activateChip(item.id)"
               (keydown.space)="activateChip(item.id); $event.preventDefault()">
            <svg class="sm-chip-symbol"
                 [class.sm-chip-symbol-dark]="isLightColor(item.color)"
                 width="20" height="20" viewBox="0 0 24 24"
                 [innerHTML]="(symbolById.get(item.symbolId)?.svg || '') | safeHtml"></svg>
            <button type="button"
                    class="sm-chip-edit"
                    (click)="openPaletteEditor(item.id); $event.stopPropagation()"
                    title="Edit">✎</button>
          </div>
          <button type="button" class="sm-add-btn" (click)="addPaletteItem()" title="Add palette entry">+</button>
        </div>

        <label class="sm-row">
          <span>Draft color</span>
          <input type="color" [(ngModel)]="draftColor" />
        </label>

        <div class="sm-editor" *ngIf="editingPaletteItemId && paletteItemById.get(editingPaletteItemId) as editing">
          <div class="sm-editor-header">
            <strong>Edit "{{ editing.name || editing.color }}"</strong>
            <button type="button" class="sm-link-btn" (click)="closePaletteEditor()">Close</button>
          </div>
          <label class="sm-row">
            <span>Color</span>
            <input type="color"
                   [ngModel]="editing.color"
                   (ngModelChange)="updatePaletteItem(editing.id, { color: $event })" />
          </label>
          <label class="sm-row">
            <span>Name</span>
            <input type="text"
                   [ngModel]="editing.name || ''"
                   (ngModelChange)="updatePaletteItem(editing.id, { name: $event })"
                   placeholder="optional name" />
          </label>
          <label class="sm-row">
            <span>DMC code</span>
            <input type="text"
                   [ngModel]="editing.dmcCode || ''"
                   (ngModelChange)="updatePaletteItem(editing.id, { dmcCode: $event })"
                   placeholder="e.g. 310" />
          </label>
          <div class="sm-editor-symbols">
            <h3 class="sm-section-title">Symbol</h3>
            <div class="sm-symbol-grid">
              <button *ngFor="let s of stitchSymbols"
                      type="button"
                      class="sm-symbol-cell"
                      [class.sm-symbol-cell-active]="s.id === editing.symbolId"
                      [class.sm-symbol-cell-taken]="isSymbolTakenByOther(s.id, editing.id)"
                      [title]="s.name"
                      (click)="updatePaletteItem(editing.id, { symbolId: s.id })">
                <svg width="20" height="20" viewBox="0 0 24 24"
                     [innerHTML]="s.svg | safeHtml"></svg>
              </button>
            </div>
          </div>
          <div class="sm-editor-actions">
            <button type="button" class="sm-btn sm-btn-danger"
                    (click)="deletePaletteItem(editing.id)">Delete</button>
          </div>
        </div>
      </section>

      <section class="sm-section">
        <h2 class="sm-section-title">View</h2>
        <label class="sm-row">
          <span>Grid lines</span>
          <input type="checkbox" [(ngModel)]="showGridLines" />
        </label>
        <div class="sm-row">
          <span>Zoom</span>
          <span class="sm-zoom-controls">
            <button type="button" class="sm-btn-small" (click)="zoomOut()">−</button>
            <span class="sm-zoom-value">{{ (zoomLevel * 100) | number:'1.0-0' }}%</span>
            <button type="button" class="sm-btn-small" (click)="zoomIn()">+</button>
            <button type="button" class="sm-btn-small" (click)="fitToScreen(canvasWrap.clientWidth, canvasWrap.clientHeight)">Fit</button>
          </span>
        </div>
      </section>

      <section class="sm-section">
        <h2 class="sm-section-title">Grid size</h2>
        <label class="sm-row">
          <span>Columns</span>
          <input type="number" [(ngModel)]="x" (change)="createGrid()" min="1" />
        </label>
        <label class="sm-row">
          <span>Rows</span>
          <input type="number" [(ngModel)]="y" (change)="createGrid()" min="1" />
        </label>
      </section>

      <section class="sm-section">
        <h2 class="sm-section-title">Pattern{{ selectedPatternId && patternName ? ' · ' + patternName : '' }}</h2>
        <div class="sm-btn-row">
          <button type="button" class="sm-btn sm-btn-primary" (click)="showSaveModal = true">Save</button>
          <button type="button" class="sm-btn" (click)="updatePattern()" [disabled]="!selectedPatternId">Update</button>
          <button type="button" class="sm-btn" (click)="showPatternsModal = true">Open…</button>
          <button type="button" class="sm-btn sm-btn-danger" (click)="deletePattern(selectedPatternId!)" [disabled]="!selectedPatternId">Delete</button>
        </div>
      </section>

    </div>
  </aside>

</div>

<!-- Save Pattern Modal (kept as-is) -->
<div class="modal-backdrop" *ngIf="showSaveModal">
  <div class="modal-dialog-centered modal-save-pattern">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Save Pattern</h5>
        <button type="button" class="btn-close" (click)="showSaveModal = false"></button>
      </div>
      <div class="modal-body">
        <label class="form-label">Pattern Name:
          <input type="text" [(ngModel)]="patternName" class="form-control" placeholder="Pattern name" />
        </label>
        <label class="form-label">Author:
          <input type="text" [(ngModel)]="author" class="form-control" placeholder="Author" />
        </label>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="showSaveModal = false">Cancel</button>
        <button class="btn btn-primary" [disabled]="!patternName" (click)="savePattern(); showSaveModal = false;">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- Saved Patterns Modal (kept as-is) -->
<div class="modal-backdrop" *ngIf="showPatternsModal">
  <div class="modal-dialog-centered modal-saved-patterns">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Saved Patterns</h5>
        <button type="button" class="btn-close" (click)="showPatternsModal = false"></button>
      </div>
      <div class="modal-body saved-patterns-scroll">
        <div *ngFor="let pattern of patterns" class="saved-pattern-card" (click)="selectPattern(pattern); showPatternsModal = false;">
          <div class="saved-pattern-name">{{pattern.name}}</div>
          <div class="saved-pattern-author">{{pattern.author}}</div>
          <div class="saved-pattern-size">{{pattern.width}} x {{pattern.height}}</div>
          <div class="saved-pattern-date">{{pattern.dateCreated | date:'short'}}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="showPatternsModal = false">Close</button>
      </div>
    </div>
  </div>
</div>
